/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
  PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams,
  PostApiV1ExamRevisionLangBotexamlangidQuestion400,
  PostApiV1ExamRevisionLangBotexamlangidQuestion401,
  PostApiV1ExamRevisionLangBotexamlangidQuestion500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLangBotexamlangidQuestion.ts";

function getPostApiV1ExamRevisionLangBotexamlangidQuestionUrl(
  botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/exam/revision/lang/${botExamLangId}/question` as const,
  };
  return res;
}

/**
 * @description Cria uma nova questão vazia para a lang de prova gerada por IA informada, replicando automaticamente para todos os demais idiomas cadastrados para a mesma prova. Cada questão é criada com 4 opções, sendo a primeira marcada como correta por padrão. **(Requer Authorization para autenticação)**
 * @summary Criar questão para todos os idiomas (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/question}
 */
export async function postApiV1ExamRevisionLangBotexamlangidQuestion(
  botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidQuestion400
      | PostApiV1ExamRevisionLangBotexamlangidQuestion401
      | PostApiV1ExamRevisionLangBotexamlangidQuestion500
    >,
    unknown
  >({
    method: "POST",
    url: getPostApiV1ExamRevisionLangBotexamlangidQuestionUrl(
      botExamLangId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
